import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  Input,
  QueryList,
  inject
} from '@angular/core';

import { Observable } from 'rxjs';

import { queryListToArrayObservable } from '@hdms/shared/util-core';

import { TabAbstractComponent } from './tab-abstract.component';
import { TabService } from './tab.service';

@Component({
  selector: 'shrd-uic-tab-group',
  templateUrl: './tab-group.component.html',
  styleUrls: ['./tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabGroupComponent implements AfterContentInit {
  @ContentChildren(TabAbstractComponent)
  readonly tabList: QueryList<TabAbstractComponent>;

  allTabs: Observable<TabAbstractComponent[]>;

  @Input() disableKeyboardNavigation = false;

  private readonly tabService = inject(TabService);

  ngAfterContentInit(): void {
    this.allTabs = queryListToArrayObservable(this.tabList);

    if (!this.hasActive()) {
      this.activateTab(0);
    } else {
      this.tabService.refresh();
    }
  }

  hasActive(): boolean {
    return this.tabService.getActive() !== undefined;
  }

  private activateTab(index: number): void {
    const tab = this.tabList.toArray()[index];
    if (typeof tab !== 'undefined') {
      tab.changeActive();
    }
  }
}
